let host;
let ossURL;

if (process.env.NODE_ENV === 'development') {
  // host = 'http://47.96.188.225:6611';
  host = 'http://192.168.1.55:5566';
  // host = 'http://192.168.1.88:5566';
  host = 'https://sh.immgj.com.cn/api';
}
else {
  // host = window.location.origin + '/api';
  // host = 'https://apiapppublic.lijuyun.cn';
  host = 'https://sh.immgj.com.cn/api';
  // host = 'http://192.168.1.78:5566';

}

export { host, ossURL };